module.exports = __webpack_public_path__ + "media/images/creator/home/about-02-b3e65d796fc50fc8e9d042fb64845ec9.png";